import { secret } from './domain-string.js';
export const AuthToken = secret('auth-token');
export const GoogleIdToken = secret('google-id-token');
//# sourceMappingURL=auth.js.map